module.exports = __webpack_public_path__ + "static/media/file_theme2.a5906a12.svg";